
































import { Mixins, Component } from 'vue-property-decorator';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import AuthWrapper from '@/components/global/AuthWrapper.vue';
import ResetPasswordForm from '@/components/resetPassword/ResetPasswordForm.vue';

import moment from 'moment';

const uuidv4 = require('uuid/v4');

@Component({
    components: {
        AuthWrapper,
        ResetPasswordForm,
    },
})
export default class ResetPassword extends Mixins(IsMobileMixin) {
    get aspectRatio() {
        if (!this.isTablet) {
            return 16 / 10;
        }
        return 'false';
    }
}
